import { motion } from 'framer-motion';

const How = () => {
  const steps = [
    {
      number: 1,
      title: 'Data Stamping',
      description:
        'Data is hashed and recorded on the Minima blockchain in real time, ensuring immutability through unique hash generation.',
    },
    {
      number: 2,
      title: 'Verification & Matching',
      description:
        'Data is verified by checking blockchain hashes against uploaded data. Integritas determines matches between dataset hashes.',
    },
    {
      number: 3,
      title: 'Report Generation',
      description:
        'Detailed verification reports include timestamps and hash records, generating NFTs and PDFs as backed proof of authenticity.',
    },
  ];

  return (
    <div className="relative max-w-4xl mx-auto py-16 px-4 mb-8">
      <div className="absolute left-1/2 transform -translate-x-px h-full w-[2px] bg-gradient-to-b from-[#ff8630]/20 via-[#ff8630]/70 to-transparent" />

      {steps.map((step, index) => (
        <motion.div
          key={step.number}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.4 }}
          className="relative flex items-center mb-16 last:mb-0"
        >
          <div className="flex-1 pr-8 text-right md:pr-16">
            {index % 2 === 0 && (
              <div>
                <h3 className="text-[20px] font-semibold mb-2 text-[#ff8630]">{step.title}</h3>
                <p className="text-core-grey-150">{step.description}</p>
              </div>
            )}
          </div>

          <div className="relative z-10">
            <div className="w-12 h-12 rounded-full border-2 border-[#ff8630]/30 bg-gray-900 flex items-center justify-center">
              <span className="absolute inset-0 flex items-center justify-center text-sm font-semibold text-white">
                {step.number}
              </span>
            </div>
          </div>

          <div className="flex-1 pl-8 md:pl-16">
            {index % 2 === 1 && (
              <div>
                <h3 className="text-[20px] font-semibold mb-2 text-[#ff8630]">{step.title}</h3>
                <p className="text-core-grey-150">{step.description}</p>
              </div>
            )}
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default How;
